import { render } from "./AreaChart.vue?vue&type=template&id=7ca774df"
import script from "./AreaChart.vue?vue&type=script&lang=js"
export * from "./AreaChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__